import {
  TOGGLE_DARK_MODE,
  TOGGLE_All,
  TOGGLE_LANGUAGE,
  SET_SIDEBAR_STYLE
} from './ActionTypes';


// Action Creators
const toggleLanguage = (language) => ({
  type: TOGGLE_LANGUAGE,
  payload: language
});

const toggleDarkMode = () => ({
  type: TOGGLE_DARK_MODE,
});


const toggleAll = () => ({
  type: TOGGLE_All,
});

// New action creator to change persisted sidebar style
const setSidebarStyle = (style) => ({
  type: SET_SIDEBAR_STYLE,
  payload: style, // expected: 'default' | 'no-bg-no-border' | 'bg-no-border'
});

export {
  toggleDarkMode,
  toggleAll,
  toggleLanguage,
  setSidebarStyle
  
};